import React, { useEffect, useState } from 'react';
import { useStore, useSelector, useDispatch } from 'react-redux';
import { OneFormState, IdDealer } from 'src/types';
import { Breakpoints, Text, Layout, Fieldset, RadioButton, Container, ContainerPadding } from '@volkswagen-onehub/components-core';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { strTitlelize } from 'src/helpers';
import { sanitizeKvps } from '../helpers';

interface DealerCEMSegundaEntregaProps {
	name: string;
	dealers?: IdDealer[];
}

export const DealerCEMSegundaEntrega = (props: DealerCEMSegundaEntregaProps) => {
	const {
		name,
		dealers
	} = props;
	const dispatch = useDispatch();
	const { handleNextStep } = useOneFormContext();
	const { formData } = useSelector((state: OneFormState) => state);
	const { fields } = formData;

	const handleSelectDealer = (e: any, dealer: IdDealer) => {
		selectDealer(dealer);
		handleNextStep(e);
	};

	const selectDealer = (dealer: IdDealer) => {
		dispatch({ type: 'UPDATE_FIELDS', payload: { [name]: sanitizeKvps(dealer.KVPSCode__c) } });
		dispatch({ type: 'SET_SELECTED_INSTALLATION', payload: dealer });
		const literalDealer = strTitlelize(dealer.VGED_CommercialName__c + ', ' + dealer.ShippingStreet + ' ' + dealer.ShippingPostalCode + ' ' + dealer.ShippingCity);
		dispatch({ type: 'UPDATE_LITERAL_FIELDS_STEPS', payload: { [name] : literalDealer } });
	};

	return (
		<Layout appearance={{
			[Breakpoints.default]: [
				{ name: '.', columns: 5 },
				{ name: 'a', columns: 12 },
				{ name: '.', columns: 5 },
			]
		}}
		>
			<Container padding={{ top: ContainerPadding.dynamic0100 }}>
				<Fieldset>
					{dealers ? dealers.map((dealer: IdDealer, index) => {
						if(!fields[name] && index == 0) {
							selectDealer(dealer); // Default selected dealer
						}
						const value = sanitizeKvps(dealer.KVPSCode__c);
						const label = <>
							<Text bold>{strTitlelize(dealer.VGED_CommercialName__c)}</Text>{' '}
							<Text>{strTitlelize(dealer.ShippingStreet)}</Text>
							<Text>{dealer.ShippingPostalCode} {strTitlelize(dealer.ShippingCity)}</Text>
						</>;
						return (<RadioButton
							key={dealer.KVPSCode__c || index}
							onClick={(e) => {
								handleSelectDealer(e, dealer);
							}}
							value={value}
							label={label}
							name={name}
							defaultChecked={fields[name] ? fields[name] == value : index == 0}
						/>);
					}) : null}
				</Fieldset>
			</Container>
		</Layout >
	);
};
